module.exports = __webpack_public_path__ + "img/uptime.fdc029d.svg";